// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/header.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/footer.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/home_web.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/home_mobile.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/about_web.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/about_mobile.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/news_web.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/news_mobile.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/academy_web.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/style/academy_mobile.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
.section-vw100 {
  width: 100vw;
}

button {
  margin: 0em;
  padding-block: 0;
  padding-inline: 0;
  border-width: 0;
}

input:is([type="button"], [type="submit"], [type="reset"]),
input[type="file"]::file-selector-button,
button {
  align-items: unset;
  text-align: unset;
  cursor: default;
  color: unset;
  padding-block-start: unset;
  padding-block-end: unset;
  padding-inline-start: unset;
  border-top-width: unset;
  border-right-width: unset;
  border-bottom-width: unset;
  border-left-width: unset;
  border-top-style: unset;
  border-right-style: unset;
  border-bottom-style: unset;
  border-left-style: unset;
  border-top-color: unset;
  border-right-color: unset;
  border-bottom-color: unset;
  border-left-color: unset;
  background-color: unset;
  box-sizing: unset;
}

body {
  margin: 0px;
  padding: 0px;
  font-size: 12px;
  width: 100vw;
  overflow-x: hidden;
}

a {
  text-decoration: none !important;
}

a:-webkit-any-link {
  text-decoration: none !important;
  color: #fcfcfc;
}

p {
  display: block;
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  unicode-bidi: isolate;
  padding: 0px;
}

ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 0em;
  unicode-bidi: isolate;
  padding: 0px;
}

.text-center {
  text-align: center;
}

.color-text-dark {
  color: #333;
}

.color-text-grey {
  color: #777;
}

.color-primary {
  color: #ecebe6;
}

.bg-white {
  background-color: #fff;
}

.bg-light-grey {
  background-color: #fcfcfc;
}

.bg-primary {
  background-color: #ecebe6;
}

.bg-secondary {
  background-color: #cbbaa6;
}

.bg-active {
  background-color: #7ba7c2;
}

.section-shadow {
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
}

.section-title {
  font-family: "Nelphim";
  font-size: 4em;
  letter-spacing: 1px;
}

.section-title-modal {
  font-family: "Nelphim";
  font-size: 2em;
  letter-spacing: 1px;
}

.section-detail-large {
  font-family: "BarlowBold", sans-serif;
  font-size: 1.5em;
  text-align: justify;
}

.section-detail {
  font-family: "Barlow";
  font-size: 1.3em;
}

.section-detail-small {
  font-family: "Barlow";
  font-size: 1.2em;
  line-height: 1.5;
}

.section-tag {
  display: flex;
  align-items: center;
  font-family: "Barlow";
  font-size: 1.3em;
}

.section-tag .dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 12px;
}

button,
.btn {
  font-size: 1.3em;
  font-family: "Barlow";
}

.btn-primary {
  color: #fcfcfc;
  border: 0;
  border-radius: 20px;
  position: relative;
  z-index: 20;
  transition: 0.3s all ease-in-out;
  display: flex;
  align-items: center;
  width: max-content;
}

.btn-primary:before {
  border-radius: 20px;
  background-color: #7ba7c2;
  position: absolute;
  display: flex;
  align-items: center;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s all ease-in-out;
  z-index: -1;
}

.btn-primary svg {
  position: relative;
  padding: 0em 0em 0em 12px;
}

.btn-primary:hover {
  background-color: unset;
  left: 0px;
  padding-left: 54px;
  color: #fff;
}

.btn-primary:hover .btn-text {
  padding: 10px 0px 10px 0px;
}

.btn-primary:hover svg {
  position: absolute;
  left: 8px;
  bottom: 10px;
}

.btn-primary:hover:before {
  width: 100%;
}

.btn-secondary {
  color: #fcfcfc;
  border: 0;
  border-radius: 20px;
  position: relative;
  z-index: 20;
  transition: 0.3s all ease-in-out;
  display: flex;
  align-items: center;
  width: max-content;
}

.btn-text {
  padding: 10px 0px 10px 24px;
}

.btn-icon {
  padding: 10px 24px 10px 0px;
}

.btn-secondary:before {
  border-radius: 20px;
  background-color: #cbbaa6;
  position: absolute;
  display: flex;
  align-items: center;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s all ease-in-out;
  z-index: -1;
}

.btn-secondary svg {
  position: relative;
  padding: 0em 0em 0em 12px;
}

.btn-secondary:hover {
  background-color: unset;
  left: 0px;
  padding-left: 54px;
  color: #fff;
}

.btn-secondary:hover .btn-text {
  padding: 10px 0px 10px 0px;
}

.btn-secondary:hover svg {
  position: absolute;
  left: 8px;
  bottom: 10px;
}

.btn-secondary:hover:before {
  width: 100%;
}

.yarl__thumbnails_thumbnail {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.yarl__thumbnails_thumbnail_active {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.accordion-container {
  width: 100%;
  overflow: hidden;
}

.accordion-item {
  display: flex;
  padding: 30px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 30px;
  border: 1px solid #eee;
  background: #fff;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.accordion-item:last-child {
  margin-bottom: 0px;
}

.accordion-wrapper .accordion-item h3.accordion-title {
  margin: 0;
  width: 100%;
}

.accordion-wrapper .accordion-item h3.accordion-title button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  width: 100%;
  text-align: left;
  color: #333;
  font-family: "BarlowBold";
  padding: 0px;
  background-color: transparent;
}

.accordion-wrapper .accordion-item h3.accordion-title button.active {
  color: #7ba7c2;
}

.accordion-wrapper .accordion-item h3.accordion-title button span.title-wrapper {
  display: block;
  position: relative;
  width: 100%;
}

.accordion-wrapper .accordion-item h3.accordion-title button span.icon-wrapper {
  display: flex;
  justify-content: center;
}

.accordion-wrapper .accordion-item h3.accordion-title button span.icon-wrapper span.minus {
  width: 24px;
  height: 24px;
}

.accordion-wrapper .accordion-item h3.accordion-title button span.icon-wrapper span.plus {
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  transition-timing-function: ease-in-out;
  transition: all 1s;
}

.accordion-wrapper .accordion-item .accordion-panel .panel-close {
  box-sizing: border-box;
  opacity: 0;
  width: 100%;
  height: 0;
  overflow: hidden;
  transition: 0.2s ease-in-out;
}

.accordion-wrapper .accordion-item .accordion-panel .panel-open {
  overflow: hidden;
  font-family: "Barlow";
  opacity: 1;
  width: 100%;
  height: auto;
  transition: 0.2s ease-in-out;
  transform-origin: center;
  line-height: 1.5;
  padding-top: 24px;
}

/* modal */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
}

.modal {
  background-color: #fcfcfc;
  border-radius: 20px;
  position: relative;
  max-width: 500px;
  min-height: 20vh;
  width: 80%;
  padding: 30px;
}

.modal-title {
  padding: 0px 0px 30px 0px;
}

.modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: center;
}

.modal-grid-col {
  padding: 0px 30px 30px 30px;
}

.modal-grid-col:first-child {
  border-right: 1px solid #ecebe6;
}

.contact-icon {
  padding: 12px;
  color: #7ba7c2;
}

.btn-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  cursor: pointer;
}

.close-button {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  overflow: hidden;
}

.close-button>div {
  position: relative;
}

.close-button-block {
  width: 24px;
  height: 12px;
  position: relative;
  overflow: hidden;
}

.close-button-block:before,
.close-button-block:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: calc(55% - 3px);
  display: block;
  width: 3px;
  height: 24px;
  transform-origin: bottom center;
  background: #7ba7c2;
  transition: all ease-out 280ms;
}

.close-button-block:last-of-type {
  transform: rotate(180deg);
}

.close-button .in .close-button-block:before {
  transition-delay: 280ms;
  transform: translateX(20px) translateY(-20px) rotate(45deg);
}

.close-button .in .close-button-block:after {
  transition-delay: 280ms;
  transform: translateX(-22px) translateY(-22px) rotate(-45deg);
}

.close-button .out {
  position: absolute;
  top: 0;
  left: 0;
}

.close-button .out .close-button-block:before {
  transform: translateX(-5px) translateY(5px) rotate(45deg);
}

.close-button .out .close-button-block:after {
  transform: translateX(5px) translateY(5px) rotate(-45deg);
}

.close-button:hover .in .close-button-block:before {
  transform: translateX(-5px) translateY(5px) rotate(45deg);
}

.close-button:hover .in .close-button-block:after {
  transform: translateX(5px) translateY(5px) rotate(-45deg);
}

.close-button:hover .out .close-button-block:before {
  transform: translateX(-20px) translateY(20px) rotate(45deg);
}

.close-button:hover .out .close-button-block:after {
  transform: translateX(20px) translateY(20px) rotate(-45deg);
}
.card-slider-container{
  width:100%;
  height:100%;
  display:flex;
  justify-content : center;
  align-items : center;
  position:absolute;
}

.slider{
  width:100%;
  height:100%;
}

.slider-icon.left , .slider-icon.right{
  background:white;
  border-radius:100%;
  position:absolute;
  opacity:0.2;
  box-shadow: 5px 5px 1.25rem 0px rgb(0 0 0 / 12%);
  cursor: pointer;
}
.slider-icon.left{
  left:0;
}
.slider-icon.right{
  right:0;
}
.slider-icon.left:hover , .slider-icon.right:hover{
  opacity:1;
}
.slider-card{
  display:inline-block;
  width:320px;
  height:300px;
  background:white;
  border-radius:10px;
  margin-left:5px;
  margin-right:5px;
  box-shadow: 5px 5px 1.25rem 0px rgb(0 0 0 / 12%);
  position: relative;
}

.slider{
  width:100%;
  height:100%;
  white-space:nowrap;
}

.slider{
  width:100%;
  height:100%;
  white-space:nowrap;
  overflow-x:scroll;
}

.slider::-webkit-scrollbar{
  display:none;
}
.slider{
  width:100%;
    height:100%;
    white-space:nowrap;
    overflow-x:scroll;

    scrollbar-width:none;

    scroll-behavior : smooth;
}

@media only screen and (max-device-width: 768px) {
  .section-title {
    font-family: "Nelphim";
    font-size: 4.5em;
    letter-spacing: 0px;
  }

  .section-detail-large {
    font-family: "BarlowBold", sans-serif;
    font-size: 1.5em;
  }

  .section-detail {
    font-family: "Barlow";
    font-size: 1.3em;
  }

  .section-detail-small {
    font-family: "BarlowLight";
    font-size: 1.2em;
  }

  .section-tag {
    display: flex;
    align-items: center;
    font-family: "Barlow";
    font-size: 1.3em;
  }

  .section-tag .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 12px;
  }

  button,
  .btn {
    font-size: 1.2em;
    font-family: "Barlow";
  }

  .btn-primary {
    color: #fcfcfc;
    border: 0;
    border-radius: 10px;
    position: relative;
    z-index: 20;
    transition: 0.3s all ease-in-out;
    display: flex;
    align-items: center;
  }

  .btn-primary:before {
    border-radius: 10px;
    background-color: #7ba7c2;
    position: absolute;
    display: flex;
    align-items: center;
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: 0.3s all ease-in-out;
    z-index: -1;
  }

  .btn-primary svg {
    position: relative;
    padding: 0em 0em 0em 12px;
  }

  .btn-primary:hover {
    background-color: unset;
    left: 0px;
    padding-left: 44px;
    color: #fff;
  }

  .btn-primary:hover svg {
    position: absolute;
    left: 0px;
  }

  .btn-primary:hover:before {
    width: calc(100% - 44px);
  }

  .btn-secondary {
    color: #fcfcfc;
    border: 0;
    border-radius: 10px;
    position: relative;
    z-index: 20;
    transition: 0.3s all ease-in-out;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .btn-secondary:before {
    border-radius: 10px;
    background-color: #7ba7c2;
    position: absolute;
    display: flex;
    align-items: center;
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: 0.3s all ease-in-out;
    z-index: -1;
  }

  .btn-secondary svg {
    position: relative;
    padding: 0em 0em 0em 12px;
  }

  .btn-secondary:hover {
    background-color: unset;
    left: 0px;
    padding-left: 54px;
    color: #fff;
  }

  .btn-secondary:hover svg {
    position: absolute;
    left: 8px;
    /* left: unset;
    */
  }

  .btn-secondary:hover:before {
    width: 100%;
  }

  .accordion-item {
    padding: 16px;
    border-radius: 20px;
    margin-bottom: 16px;
  }
}

@media only screen and (max-device-width: 480px) {

  /* modal */
  .section-title {
    font-family: "Nelphim";
    font-size: 3em;
    letter-spacing: 0px;
  }

  .section-detail-large {
    font-family: "Barlow", sans-serif;
    font-size: 1.4em;
  }

  .section-detail {
    font-family: "Barlow";
    font-size: 1.2em;
  }

  .section-detail-small {
    font-family: "BarlowLight";
    font-size: 1.1em;
  }

  .section-tag {
    display: flex;
    align-items: center;
    font-family: "Barlow";
    font-size: 1.2em;
  }

  .section-tag .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 12px;
  }

  button,
  .btn {
    font-size: 1.2em;
    font-family: "Barlow";
  }

  .btn-primary {
    color: #fcfcfc;
    border: 0;
    border-radius: 10px;
    position: relative;
    z-index: 20;
    transition: none;
    display: flex;
    align-items: center;
  }

  .btn-primary .btn-text {
    padding: 10px;
  }

  .btn-primary:before {
    border-radius: 10px;
    background-color: #7ba7c2;
    position: absolute;
    display: flex;
    align-items: center;
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: none;
    z-index: -1;
  }

  .btn-primary svg {
    position: relative;
    padding: 0em 0em 0em 12px;
  }

  .btn-primary:hover {
    background-color: unset;
    left: unset;
    bottom: unset;
    padding-left: 0px;
    color: #fff;
  }

  .btn-primary:hover .btn-text {
    padding-left: 10px;
  }

  .btn-primary:hover svg {
    position: relative;
    left: unset;
    bottom: unset;
  }

  .btn-primary:hover:before {
    width: 100%;
  }

  .btn-secondary {
    color: #fcfcfc;
    border: 0;
    border-radius: 10px;
    position: relative;
    z-index: 20;
    transition: 0.3s all ease-in-out;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .btn-secondary:before {
    border-radius: 10px;
    background-color: #cbbaa6;
    position: absolute;
    display: flex;
    align-items: center;
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: 0.3s all ease-in-out;
    z-index: -1;
  }

  .btn-secondary svg {
    position: relative;
    padding: 0em 0em 0em 10px;
  }

  .btn-text {
    padding-left: 10px;
  }

  .btn-icon {
    padding: 10px 10px 10px 0px;
  }

  .btn-secondary:hover {
    background-color: unset;
    left: unset;
    bottom: unset;
    padding-left: 0px;
    color: #fff;
  }

  .btn-secondary:hover .btn-text {
    padding-left: 10px;
  }

  .btn-secondary:hover svg {
    width: 20px;
    height: 20px;
    position: relative;
    padding: 0em 0em 0em 10px;
    left: unset;
    bottom: unset;
  }

  .btn-secondary:hover:before {
    width: 100%;
  }

  .accordion-item {
    padding: 16px;
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .modal {
    background-color: #fcfcfc;
    border-radius: 20px;
    position: relative;
    max-width: 500px;
    min-height: 20vh;
    width: 80%;
    padding: 30px;
  }

  .modal-title {
    padding: 0px 0px 20px 0px;
  }

  .modal-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    text-align: center;
  }

  .modal-grid-col {
    padding: 0px 16px 16px 16px;
  }

  .modal-grid-col:first-child {
    border-right: 0px solid #ecebe6;
  }

  .close-button {
    width: 16px;
    height: 16px;
  }

  .close-button-block {
    width: 16px;
    height: 8px;
  }

  .close-button-block:before,
  .close-button-block:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: calc(55% - 2px);
    display: block;
    width: 2px;
    height: 16px;
    transform-origin: bottom center;
    background: #7ba7c2;
    transition: all ease-out 280ms;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";;AAeA;EACE,qBAAqB;EACrB,4EAA8E;AAChF;;AAEA;EACE,yBAAyB;EACzB,gFAAiF;AACnF;;AAEA;EACE,sBAAsB;EACtB,8EAA0E;AAC5E;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,uFAAuF;AACzF;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,2DAA2D;AAC7D;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gDAAgD;EAChD,eAAe;AACjB;AACA;EACE,MAAM;AACR;AACA;EACE,OAAO;AACT;AACA;EACE,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;IACR,WAAW;IACX,kBAAkB;IAClB,iBAAiB;;IAEjB,oBAAoB;;IAEpB,wBAAwB;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT;KACC;EACH;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;;EAEE,UAAU;EACV;IACE,sBAAsB;IACtB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,8BAA8B;EAChC;AACF","sourcesContent":["\n\n@import url(./assets/style/header.css);\n@import url(./assets/style/footer.css);\n\n@import url(./assets/style/home_web.css);\n@import url(./assets/style/home_mobile.css);\n@import url(./assets/style/about_web.css);\n\n@import url(./assets/style/about_mobile.css);\n@import url(./assets/style/news_web.css);\n@import url(./assets/style/news_mobile.css);\n@import url(./assets/style/academy_web.css);\n@import url(./assets/style/academy_mobile.css);\n\n@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"./assets/fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"./assets/fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"./assets/fonts/Nelphim.woff2\") format(\"woff2\");\n}\n.section-vw100 {\n  width: 100vw;\n}\n\nbutton {\n  margin: 0em;\n  padding-block: 0;\n  padding-inline: 0;\n  border-width: 0;\n}\n\ninput:is([type=\"button\"], [type=\"submit\"], [type=\"reset\"]),\ninput[type=\"file\"]::file-selector-button,\nbutton {\n  align-items: unset;\n  text-align: unset;\n  cursor: default;\n  color: unset;\n  padding-block-start: unset;\n  padding-block-end: unset;\n  padding-inline-start: unset;\n  border-top-width: unset;\n  border-right-width: unset;\n  border-bottom-width: unset;\n  border-left-width: unset;\n  border-top-style: unset;\n  border-right-style: unset;\n  border-bottom-style: unset;\n  border-left-style: unset;\n  border-top-color: unset;\n  border-right-color: unset;\n  border-bottom-color: unset;\n  border-left-color: unset;\n  background-color: unset;\n  box-sizing: unset;\n}\n\nbody {\n  margin: 0px;\n  padding: 0px;\n  font-size: 12px;\n  width: 100vw;\n  overflow-x: hidden;\n}\n\na {\n  text-decoration: none !important;\n}\n\na:-webkit-any-link {\n  text-decoration: none !important;\n  color: #fcfcfc;\n}\n\np {\n  display: block;\n  margin-block-start: 0em;\n  margin-block-end: 0em;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n  unicode-bidi: isolate;\n  padding: 0px;\n}\n\nul {\n  display: block;\n  list-style-type: disc;\n  margin-block-start: 0em;\n  margin-block-end: 0em;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n  padding-inline-start: 0em;\n  unicode-bidi: isolate;\n  padding: 0px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.color-text-dark {\n  color: #333;\n}\n\n.color-text-grey {\n  color: #777;\n}\n\n.color-primary {\n  color: #ecebe6;\n}\n\n.bg-white {\n  background-color: #fff;\n}\n\n.bg-light-grey {\n  background-color: #fcfcfc;\n}\n\n.bg-primary {\n  background-color: #ecebe6;\n}\n\n.bg-secondary {\n  background-color: #cbbaa6;\n}\n\n.bg-active {\n  background-color: #7ba7c2;\n}\n\n.section-shadow {\n  border-bottom-right-radius: 12px;\n  border-bottom-left-radius: 12px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n}\n\n.section-title {\n  font-family: \"Nelphim\";\n  font-size: 4em;\n  letter-spacing: 1px;\n}\n\n.section-title-modal {\n  font-family: \"Nelphim\";\n  font-size: 2em;\n  letter-spacing: 1px;\n}\n\n.section-detail-large {\n  font-family: \"BarlowBold\", sans-serif;\n  font-size: 1.5em;\n  text-align: justify;\n}\n\n.section-detail {\n  font-family: \"Barlow\";\n  font-size: 1.3em;\n}\n\n.section-detail-small {\n  font-family: \"Barlow\";\n  font-size: 1.2em;\n  line-height: 1.5;\n}\n\n.section-tag {\n  display: flex;\n  align-items: center;\n  font-family: \"Barlow\";\n  font-size: 1.3em;\n}\n\n.section-tag .dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-right: 12px;\n}\n\nbutton,\n.btn {\n  font-size: 1.3em;\n  font-family: \"Barlow\";\n}\n\n.btn-primary {\n  color: #fcfcfc;\n  border: 0;\n  border-radius: 20px;\n  position: relative;\n  z-index: 20;\n  transition: 0.3s all ease-in-out;\n  display: flex;\n  align-items: center;\n  width: max-content;\n}\n\n.btn-primary:before {\n  border-radius: 20px;\n  background-color: #7ba7c2;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  content: \"\";\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transition: 0.3s all ease-in-out;\n  z-index: -1;\n}\n\n.btn-primary svg {\n  position: relative;\n  padding: 0em 0em 0em 12px;\n}\n\n.btn-primary:hover {\n  background-color: unset;\n  left: 0px;\n  padding-left: 54px;\n  color: #fff;\n}\n\n.btn-primary:hover .btn-text {\n  padding: 10px 0px 10px 0px;\n}\n\n.btn-primary:hover svg {\n  position: absolute;\n  left: 8px;\n  bottom: 10px;\n}\n\n.btn-primary:hover:before {\n  width: 100%;\n}\n\n.btn-secondary {\n  color: #fcfcfc;\n  border: 0;\n  border-radius: 20px;\n  position: relative;\n  z-index: 20;\n  transition: 0.3s all ease-in-out;\n  display: flex;\n  align-items: center;\n  width: max-content;\n}\n\n.btn-text {\n  padding: 10px 0px 10px 24px;\n}\n\n.btn-icon {\n  padding: 10px 24px 10px 0px;\n}\n\n.btn-secondary:before {\n  border-radius: 20px;\n  background-color: #cbbaa6;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  content: \"\";\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transition: 0.3s all ease-in-out;\n  z-index: -1;\n}\n\n.btn-secondary svg {\n  position: relative;\n  padding: 0em 0em 0em 12px;\n}\n\n.btn-secondary:hover {\n  background-color: unset;\n  left: 0px;\n  padding-left: 54px;\n  color: #fff;\n}\n\n.btn-secondary:hover .btn-text {\n  padding: 10px 0px 10px 0px;\n}\n\n.btn-secondary:hover svg {\n  position: absolute;\n  left: 8px;\n  bottom: 10px;\n}\n\n.btn-secondary:hover:before {\n  width: 100%;\n}\n\n.yarl__thumbnails_thumbnail {\n  border-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.yarl__thumbnails_thumbnail_active {\n  border-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.accordion-container {\n  width: 100%;\n  overflow: hidden;\n}\n\n.accordion-item {\n  display: flex;\n  padding: 30px;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  border-radius: 30px;\n  border: 1px solid #eee;\n  background: #fff;\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.accordion-item:last-child {\n  margin-bottom: 0px;\n}\n\n.accordion-wrapper .accordion-item h3.accordion-title {\n  margin: 0;\n  width: 100%;\n}\n\n.accordion-wrapper .accordion-item h3.accordion-title button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: none;\n  width: 100%;\n  text-align: left;\n  color: #333;\n  font-family: \"BarlowBold\";\n  padding: 0px;\n  background-color: transparent;\n}\n\n.accordion-wrapper .accordion-item h3.accordion-title button.active {\n  color: #7ba7c2;\n}\n\n.accordion-wrapper .accordion-item h3.accordion-title button span.title-wrapper {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n\n.accordion-wrapper .accordion-item h3.accordion-title button span.icon-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.accordion-wrapper .accordion-item h3.accordion-title button span.icon-wrapper span.minus {\n  width: 24px;\n  height: 24px;\n}\n\n.accordion-wrapper .accordion-item h3.accordion-title button span.icon-wrapper span.plus {\n  width: 24px;\n  height: 24px;\n  transform: rotate(90deg);\n  transition-timing-function: ease-in-out;\n  transition: all 1s;\n}\n\n.accordion-wrapper .accordion-item .accordion-panel .panel-close {\n  box-sizing: border-box;\n  opacity: 0;\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  transition: 0.2s ease-in-out;\n}\n\n.accordion-wrapper .accordion-item .accordion-panel .panel-open {\n  overflow: hidden;\n  font-family: \"Barlow\";\n  opacity: 1;\n  width: 100%;\n  height: auto;\n  transition: 0.2s ease-in-out;\n  transform-origin: center;\n  line-height: 1.5;\n  padding-top: 24px;\n}\n\n/* modal */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1080;\n}\n\n.modal {\n  background-color: #fcfcfc;\n  border-radius: 20px;\n  position: relative;\n  max-width: 500px;\n  min-height: 20vh;\n  width: 80%;\n  padding: 30px;\n}\n\n.modal-title {\n  padding: 0px 0px 30px 0px;\n}\n\n.modal-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  text-align: center;\n}\n\n.modal-grid-col {\n  padding: 0px 30px 30px 30px;\n}\n\n.modal-grid-col:first-child {\n  border-right: 1px solid #ecebe6;\n}\n\n.contact-icon {\n  padding: 12px;\n  color: #7ba7c2;\n}\n\n.btn-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.close-button {\n  display: block;\n  width: 24px;\n  height: 24px;\n  position: relative;\n  overflow: hidden;\n}\n\n.close-button>div {\n  position: relative;\n}\n\n.close-button-block {\n  width: 24px;\n  height: 12px;\n  position: relative;\n  overflow: hidden;\n}\n\n.close-button-block:before,\n.close-button-block:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: calc(55% - 3px);\n  display: block;\n  width: 3px;\n  height: 24px;\n  transform-origin: bottom center;\n  background: #7ba7c2;\n  transition: all ease-out 280ms;\n}\n\n.close-button-block:last-of-type {\n  transform: rotate(180deg);\n}\n\n.close-button .in .close-button-block:before {\n  transition-delay: 280ms;\n  transform: translateX(20px) translateY(-20px) rotate(45deg);\n}\n\n.close-button .in .close-button-block:after {\n  transition-delay: 280ms;\n  transform: translateX(-22px) translateY(-22px) rotate(-45deg);\n}\n\n.close-button .out {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.close-button .out .close-button-block:before {\n  transform: translateX(-5px) translateY(5px) rotate(45deg);\n}\n\n.close-button .out .close-button-block:after {\n  transform: translateX(5px) translateY(5px) rotate(-45deg);\n}\n\n.close-button:hover .in .close-button-block:before {\n  transform: translateX(-5px) translateY(5px) rotate(45deg);\n}\n\n.close-button:hover .in .close-button-block:after {\n  transform: translateX(5px) translateY(5px) rotate(-45deg);\n}\n\n.close-button:hover .out .close-button-block:before {\n  transform: translateX(-20px) translateY(20px) rotate(45deg);\n}\n\n.close-button:hover .out .close-button-block:after {\n  transform: translateX(20px) translateY(20px) rotate(-45deg);\n}\n.card-slider-container{\n  width:100%;\n  height:100%;\n  display:flex;\n  justify-content : center;\n  align-items : center;\n  position:absolute;\n}\n\n.slider{\n  width:100%;\n  height:100%;\n}\n\n.slider-icon.left , .slider-icon.right{\n  background:white;\n  border-radius:100%;\n  position:absolute;\n  opacity:0.2;\n  box-shadow: 5px 5px 1.25rem 0px rgb(0 0 0 / 12%);\n  cursor: pointer;\n}\n.slider-icon.left{\n  left:0;\n}\n.slider-icon.right{\n  right:0;\n}\n.slider-icon.left:hover , .slider-icon.right:hover{\n  opacity:1;\n}\n.slider-card{\n  display:inline-block;\n  width:320px;\n  height:300px;\n  background:white;\n  border-radius:10px;\n  margin-left:5px;\n  margin-right:5px;\n  box-shadow: 5px 5px 1.25rem 0px rgb(0 0 0 / 12%);\n  position: relative;\n}\n\n.slider{\n  width:100%;\n  height:100%;\n  white-space:nowrap;\n}\n\n.slider{\n  width:100%;\n  height:100%;\n  white-space:nowrap;\n  overflow-x:scroll;\n}\n\n.slider::-webkit-scrollbar{\n  display:none;\n}\n.slider{\n  width:100%;\n    height:100%;\n    white-space:nowrap;\n    overflow-x:scroll;\n\n    scrollbar-width:none;\n\n    scroll-behavior : smooth;\n}\n\n@media only screen and (max-device-width: 768px) {\n  .section-title {\n    font-family: \"Nelphim\";\n    font-size: 4.5em;\n    letter-spacing: 0px;\n  }\n\n  .section-detail-large {\n    font-family: \"BarlowBold\", sans-serif;\n    font-size: 1.5em;\n  }\n\n  .section-detail {\n    font-family: \"Barlow\";\n    font-size: 1.3em;\n  }\n\n  .section-detail-small {\n    font-family: \"BarlowLight\";\n    font-size: 1.2em;\n  }\n\n  .section-tag {\n    display: flex;\n    align-items: center;\n    font-family: \"Barlow\";\n    font-size: 1.3em;\n  }\n\n  .section-tag .dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    margin-right: 12px;\n  }\n\n  button,\n  .btn {\n    font-size: 1.2em;\n    font-family: \"Barlow\";\n  }\n\n  .btn-primary {\n    color: #fcfcfc;\n    border: 0;\n    border-radius: 10px;\n    position: relative;\n    z-index: 20;\n    transition: 0.3s all ease-in-out;\n    display: flex;\n    align-items: center;\n  }\n\n  .btn-primary:before {\n    border-radius: 10px;\n    background-color: #7ba7c2;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    content: \"\";\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transition: 0.3s all ease-in-out;\n    z-index: -1;\n  }\n\n  .btn-primary svg {\n    position: relative;\n    padding: 0em 0em 0em 12px;\n  }\n\n  .btn-primary:hover {\n    background-color: unset;\n    left: 0px;\n    padding-left: 44px;\n    color: #fff;\n  }\n\n  .btn-primary:hover svg {\n    position: absolute;\n    left: 0px;\n  }\n\n  .btn-primary:hover:before {\n    width: calc(100% - 44px);\n  }\n\n  .btn-secondary {\n    color: #fcfcfc;\n    border: 0;\n    border-radius: 10px;\n    position: relative;\n    z-index: 20;\n    transition: 0.3s all ease-in-out;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .btn-secondary:before {\n    border-radius: 10px;\n    background-color: #7ba7c2;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    content: \"\";\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transition: 0.3s all ease-in-out;\n    z-index: -1;\n  }\n\n  .btn-secondary svg {\n    position: relative;\n    padding: 0em 0em 0em 12px;\n  }\n\n  .btn-secondary:hover {\n    background-color: unset;\n    left: 0px;\n    padding-left: 54px;\n    color: #fff;\n  }\n\n  .btn-secondary:hover svg {\n    position: absolute;\n    left: 8px;\n    /* left: unset;\n    */\n  }\n\n  .btn-secondary:hover:before {\n    width: 100%;\n  }\n\n  .accordion-item {\n    padding: 16px;\n    border-radius: 20px;\n    margin-bottom: 16px;\n  }\n}\n\n@media only screen and (max-device-width: 480px) {\n\n  /* modal */\n  .section-title {\n    font-family: \"Nelphim\";\n    font-size: 3em;\n    letter-spacing: 0px;\n  }\n\n  .section-detail-large {\n    font-family: \"Barlow\", sans-serif;\n    font-size: 1.4em;\n  }\n\n  .section-detail {\n    font-family: \"Barlow\";\n    font-size: 1.2em;\n  }\n\n  .section-detail-small {\n    font-family: \"BarlowLight\";\n    font-size: 1.1em;\n  }\n\n  .section-tag {\n    display: flex;\n    align-items: center;\n    font-family: \"Barlow\";\n    font-size: 1.2em;\n  }\n\n  .section-tag .dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    margin-right: 12px;\n  }\n\n  button,\n  .btn {\n    font-size: 1.2em;\n    font-family: \"Barlow\";\n  }\n\n  .btn-primary {\n    color: #fcfcfc;\n    border: 0;\n    border-radius: 10px;\n    position: relative;\n    z-index: 20;\n    transition: none;\n    display: flex;\n    align-items: center;\n  }\n\n  .btn-primary .btn-text {\n    padding: 10px;\n  }\n\n  .btn-primary:before {\n    border-radius: 10px;\n    background-color: #7ba7c2;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    content: \"\";\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transition: none;\n    z-index: -1;\n  }\n\n  .btn-primary svg {\n    position: relative;\n    padding: 0em 0em 0em 12px;\n  }\n\n  .btn-primary:hover {\n    background-color: unset;\n    left: unset;\n    bottom: unset;\n    padding-left: 0px;\n    color: #fff;\n  }\n\n  .btn-primary:hover .btn-text {\n    padding-left: 10px;\n  }\n\n  .btn-primary:hover svg {\n    position: relative;\n    left: unset;\n    bottom: unset;\n  }\n\n  .btn-primary:hover:before {\n    width: 100%;\n  }\n\n  .btn-secondary {\n    color: #fcfcfc;\n    border: 0;\n    border-radius: 10px;\n    position: relative;\n    z-index: 20;\n    transition: 0.3s all ease-in-out;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .btn-secondary:before {\n    border-radius: 10px;\n    background-color: #cbbaa6;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    content: \"\";\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transition: 0.3s all ease-in-out;\n    z-index: -1;\n  }\n\n  .btn-secondary svg {\n    position: relative;\n    padding: 0em 0em 0em 10px;\n  }\n\n  .btn-text {\n    padding-left: 10px;\n  }\n\n  .btn-icon {\n    padding: 10px 10px 10px 0px;\n  }\n\n  .btn-secondary:hover {\n    background-color: unset;\n    left: unset;\n    bottom: unset;\n    padding-left: 0px;\n    color: #fff;\n  }\n\n  .btn-secondary:hover .btn-text {\n    padding-left: 10px;\n  }\n\n  .btn-secondary:hover svg {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    padding: 0em 0em 0em 10px;\n    left: unset;\n    bottom: unset;\n  }\n\n  .btn-secondary:hover:before {\n    width: 100%;\n  }\n\n  .accordion-item {\n    padding: 16px;\n    border-radius: 10px;\n    margin-bottom: 16px;\n  }\n\n  .modal {\n    background-color: #fcfcfc;\n    border-radius: 20px;\n    position: relative;\n    max-width: 500px;\n    min-height: 20vh;\n    width: 80%;\n    padding: 30px;\n  }\n\n  .modal-title {\n    padding: 0px 0px 20px 0px;\n  }\n\n  .modal-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    text-align: center;\n  }\n\n  .modal-grid-col {\n    padding: 0px 16px 16px 16px;\n  }\n\n  .modal-grid-col:first-child {\n    border-right: 0px solid #ecebe6;\n  }\n\n  .close-button {\n    width: 16px;\n    height: 16px;\n  }\n\n  .close-button-block {\n    width: 16px;\n    height: 8px;\n  }\n\n  .close-button-block:before,\n  .close-button-block:after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: calc(55% - 2px);\n    display: block;\n    width: 2px;\n    height: 16px;\n    transform-origin: bottom center;\n    background: #7ba7c2;\n    transition: all ease-out 280ms;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
